import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow, Title3 } from '@fluentui/react-components';
import { Settlement } from '../../../models/Entities/Settlements/Settlement';

interface Props {
    settlementId: number;
    settlement?: Settlement;
    getSettlementById: (id: number) => void;
}

const SettlementDetailsByConceptComponent = (props: Props) => {
    const { t } = useTranslation();

    useEffect(() => {
        if (!props.settlement) {
            props.getSettlementById(props.settlementId);
        }
    }, [props.settlementId, props.settlement]);

    if (!props.settlement) {
        return <div>{t('loading')}</div>;
    }

    // Group details by concept
    const detailsByConcept: { [conceptName: string]: { amount: number; currency: string } } = {};
    props.settlement.details?.forEach(detail => {
        detail.conceptValue?.forEach(concept => {
            if (!detailsByConcept[concept.contractConceptName]) {
                detailsByConcept[concept.contractConceptName] = { amount: 0, currency: concept.currencyCode };
            }
            detailsByConcept[concept.contractConceptName].amount += concept.value;
        });
    });
    const conceptRows = Object.entries(detailsByConcept);

    return (
        <div>
            <Title3>{t('settlementDetailsByConcept.title')}</Title3>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell>{t('settlementDetailsByConcept.concept')}</TableHeaderCell>
                        <TableHeaderCell>{t('settlementDetailsByConcept.amount')}</TableHeaderCell>
                        <TableHeaderCell>{t('settlementDetailsByConcept.currency')}</TableHeaderCell>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {conceptRows.map(([conceptName, data]) => (
                        <TableRow key={conceptName}>
                            <TableCell>{conceptName}</TableCell>
                            <TableCell>{data.amount}</TableCell>
                            <TableCell>{data.currency}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
};

const mapStateToProps = (state: any, ownProps: Props) => ({
    settlement: state.Settlement?.list?.find((s: Settlement) => s.id === ownProps.settlementId),
});

const mapDispatchToProps = {
    getSettlementById: (id: number) => ({ type: 'SETTLEMENT_GETBYID_REQUEST_ACTION', settlementId: id })
};

export default connect(mapStateToProps, mapDispatchToProps)(SettlementDetailsByConceptComponent);
